import '@vaadin/button';
import { html } from 'lit';
import { customElement, property, state } from 'lit/decorators.js';
import { classMap } from 'lit/directives/class-map.js';
import { TmBaseComponent } from '../tm-base.component';
import { LabeledListItem } from '../view-models';
import './layout/tm-section';

const tagName = 'tm-button-group';
/**
 * @fires TmButtonGroup#click - Event fired when the user clicks a button
 */
@customElement(tagName)
class TmButtonGroup<T> extends TmBaseComponent {
    @property({ attribute: false })
    public buttons: LabeledListItem<T>[] = [];

    @state()
    private selectedIndex = 0;

    protected render() {
        return html`
            <div class="flex items-center justify-center">
                ${this.buttons.map(
                    (button, i) =>
                        html`<vaadin-button
                            class=${classMap({
                                'bg-brand': i === this.selectedIndex,
                                'text-white': i === this.selectedIndex,
                                'rounded-none p-1 text-sm grow': true,
                                'bg-white': i !== this.selectedIndex,
                                'first-of-type:rounded-l-lg first-of-type:border-r-0 first-of-type:pl-3': true,
                                'last-of-type:rounded-r-lg last-of-type:border-l-0 last-of-type:pr-3': true,
                                'border-brand border': true,
                            })}
                            @click=${() => {
                                this.selectedIndex = i;
                                this.dispatchEvent(
                                    new CustomEvent('button-group-click', {
                                        detail: button.value,
                                    })
                                );
                            }}
                        >
                            ${button.label}
                        </vaadin-button>`
                )}
            </div>
        `;
    }
}

declare global {
    interface HTMLElementTagNameMap {
        [tagName]: TmButtonGroup<unknown>;
    }
}
